import { HTMLAttributes } from "react";
import { clsx } from "clsx";
import styles from "./Label.module.css";

type LabelProps = HTMLAttributes<HTMLLabelElement>;

export function Label({ children, className }: LabelProps) {
  return <label className={clsx(styles.labelRoot, className)}>{children}</label>;
}
